<template>
    <div class="navbar">
        <img src="/logo.png" @click="openlink('https://kiminjae.me')">
        <span>{{name}}</span>
    </div>
</template>

<script>
export default {
  name: 'Navbar',
  props:{
      name: {}
  },
  methods: {
    openlink(link){
      window.open(link, '_blank')
    }
  }
}
</script>

<style>
.navbar > img{
  margin: 0 20px;
  width: 80px;
  height: 80px;
}
.navbar > span {
  font-size: 3em;
  margin: auto 0;
  font-weight: bold;
  color: #ffb300;
}
.navbar{
  width: 100%;
  height: 60px;
  padding: 10px 0;
  display: flex;
  flex-direction: row;
  align-items: center;
}
@media (max-width: 480px){
    .navbar > span {
      font-size: 1em;
    }
}
</style>